"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstantGameName = exports.InstantPrizeType = exports.ValidationWinStatus = exports.ValidationDrawPrizeType = exports.ValidationDrawTicketStatus = exports.ValidationRejectReason = exports.ValidationStatus = void 0;
// shared
var ValidationStatus;
(function (ValidationStatus) {
    ValidationStatus["ACCEPTED"] = "ACCEPTED";
    ValidationStatus["REJECTED"] = "REJECTED";
})(ValidationStatus = exports.ValidationStatus || (exports.ValidationStatus = {}));
// shared
var ValidationRejectReason;
(function (ValidationRejectReason) {
    ValidationRejectReason["SCANNING_ERROR"] = "SCANNING_ERROR";
    ValidationRejectReason["NOT_A_WINNER"] = "NOT_A_WINNER";
    ValidationRejectReason["RESULTS_NOT_AVAILABLE"] = "RESULTS_NOT_AVAILABLE";
    ValidationRejectReason["CLAIM_PERIOD_EXPIRED"] = "CLAIM_PERIOD_EXPIRED";
    ValidationRejectReason["CONTACT_LOTTERY"] = "CONTACT_LOTTERY";
    ValidationRejectReason["NON_WINNER_DRAWS_REMAIN"] = "NON_WINNER_DRAWS_REMAIN";
    ValidationRejectReason["PREVIOUSLY_CASHED"] = "PREVIOUSLY_CASHED";
    ValidationRejectReason["UNKNOWN"] = "UNKNOWN";
})(ValidationRejectReason = exports.ValidationRejectReason || (exports.ValidationRejectReason = {}));
var ValidationDrawTicketStatus;
(function (ValidationDrawTicketStatus) {
    ValidationDrawTicketStatus["WINNER"] = "WINNER";
    ValidationDrawTicketStatus["NOT_A_WINNER"] = "NOT_A_WINNER";
    ValidationDrawTicketStatus["RESULTS_NOT_IN"] = "RESULTS_NOT_IN";
    ValidationDrawTicketStatus["PAID"] = "PAID";
    ValidationDrawTicketStatus["EXPIRED"] = "EXPIRED";
    ValidationDrawTicketStatus["ON_HOLD"] = "ON_HOLD";
    ValidationDrawTicketStatus["WINNER_DRAWS_REMAINING"] = "WINNER_DRAWS_REMAINING";
    ValidationDrawTicketStatus["INSTANT_WINNER_DRAWS_REMAINING"] = "INSTANT_WINNER_DRAWS_REMAINING";
    ValidationDrawTicketStatus["CLAIMED"] = "CLAIMED";
    ValidationDrawTicketStatus["NOT_WINNER_DRAWS_REMAINING"] = "NOT_WINNER_DRAWS_REMAINING";
    ValidationDrawTicketStatus["CLAIM_AT_LOTTERY"] = "CLAIM_AT_LOTTERY";
    ValidationDrawTicketStatus["CANCELED"] = "CANCELED";
})(ValidationDrawTicketStatus = exports.ValidationDrawTicketStatus || (exports.ValidationDrawTicketStatus = {}));
var ValidationDrawPrizeType;
(function (ValidationDrawPrizeType) {
    ValidationDrawPrizeType["PARAMUTUEL"] = "PARAMUTUEL";
    ValidationDrawPrizeType["FIXED"] = "FIXED";
    ValidationDrawPrizeType["FIXED_AND_PARAMUTUEL"] = "FIXED_AND_PARAMUTUEL";
    ValidationDrawPrizeType["FREE_TICKET"] = "FREE_TICKET";
    ValidationDrawPrizeType["MERCHANDISE"] = "MERCHANDISE";
    ValidationDrawPrizeType["ENTRY_TICKET"] = "ENTRY_TICKET";
    ValidationDrawPrizeType["FREE_ONLINE_TICKET"] = "FREE_ONLINE_TICKET";
    ValidationDrawPrizeType["ANNUITY"] = "ANNUITY";
})(ValidationDrawPrizeType = exports.ValidationDrawPrizeType || (exports.ValidationDrawPrizeType = {}));
var ValidationWinStatus;
(function (ValidationWinStatus) {
    ValidationWinStatus["WINNER"] = "WINNER";
    ValidationWinStatus["NOT_A_WINNER"] = "NOT_A_WINNER";
    ValidationWinStatus["ENTRY"] = "ENTRY";
})(ValidationWinStatus = exports.ValidationWinStatus || (exports.ValidationWinStatus = {}));
var InstantPrizeType;
(function (InstantPrizeType) {
    InstantPrizeType["CASH"] = "CASH";
    InstantPrizeType["ANNUITY"] = "ANNUITY";
    InstantPrizeType["FREE_INSTANT_TICKET"] = "FREE_INSTANT_TICKET";
    InstantPrizeType["ENTRY_TICKET"] = "ENTRY_TICKET";
    InstantPrizeType["MERCHANDISE"] = "MERCHANDISE";
    InstantPrizeType["FREE_ONLINE_TICKET"] = "FREE_ONLINE_TICKET";
})(InstantPrizeType = exports.InstantPrizeType || (exports.InstantPrizeType = {}));
var InstantGameName;
(function (InstantGameName) {
    InstantGameName["CASH5"] = "CASH5";
    InstantGameName["MEGAMILLIONS"] = "MEGAMILLIONS";
    InstantGameName["POWERBALL"] = "POWERBALL";
    InstantGameName["PICK3"] = "PICK3";
    InstantGameName["PICK4"] = "PICK4";
    InstantGameName["LUCKY4LIFE"] = "LUCKY4LIFE";
    InstantGameName["KENO"] = "KENO";
    InstantGameName["UNKNOWN"] = "UNKNOWN";
})(InstantGameName = exports.InstantGameName || (exports.InstantGameName = {}));
//# sourceMappingURL=validationTypes.js.map